const t = {
  name: "OauthSecurity",
  dimensions: { width: 30, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 40" style="enable-background:new 0 0 30 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,29v-8h-8v8h3v3h2v-3H19z M13,27v-4h4v4H13z"/>
		<path class="st0" d="M9,10V6c0-3.3,2.7-6,6-6s6,2.7,6,6v4h2c3.9,0,7,3.1,7,7v23H7c-3.9,0-7-3.1-7-7V10H9z M11,6v4h8V6
			c0-2.2-1.8-4-4-4S11,3.8,11,6z M2,12v21c0,2.8,2.2,5,5,5h21V17c0-2.8-2.2-5-5-5H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as OauthSecurity
};
